import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators'; // Correct import for 'tap' operator
import UserExperior from 'user-experior-web';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add additional headers if necessary
    const clonedRequest = req.clone({
      // You can add headers here if required
    });

    // Log the request details
    const ue = new UserExperior();
    ue.logEvent('API Request', {
      url: clonedRequest.url,
      method: clonedRequest.method,
      headers: clonedRequest.headers.keys().map(key => ({ key, value: clonedRequest.headers.get(key) })),
      body: clonedRequest.body
    });

    // Proceed with the request and capture the response
    return next.handle(clonedRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Log the response details
          ue.logEvent('API Response', {
            url: event.url,
            status: event.status,
            body: event.body,
            headers: event.headers.keys().map(key => ({ key, value: event.headers.get(key) }))
          });
        }
      }, (error: any) => {
        // Log error details
        ue.logEvent('API Error', {
          url: req.url,
          status: error.status,
          message: error.message,
          error: error.error
        });
      })
    );
  }
}
